// @flow

// React 16 depends on the collection types Map and Set.
// Since we support older browsers and devices which may not yet provide
// these natively (e.g. IE < 11), we include a global polyfill in our bundle.
import 'core-js/es6/map';
import 'core-js/es6/set';

// We also polyfill Array#fill so that the app doesn't crash on IE.
import 'core-js/fn/array/fill';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app';

// Global styles, CSS reset, typography, etc.
import './styles/index.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

// Log bundle information
console.info(`Version: ${process.env.REACT_APP_VERSION}`);
console.info(`Environment: ${process.env.REACT_APP_ENV}`);
